const countryTags = {
    "FR" : "France",
    "GB" : "Royaume-Uni",
}

export const defaultAddress = () => {
    return {
        name: window.i18n.__("Adresse principale"),
        type: {
            value: "invoice-delivery",
            label: window.i18n.__("Facturation & Livraison"),
        },
        isInvoicingAddress: true,
        isDeliveryAddress: true,
        active: true,
        settings: {
            line1: "",
            line2: "",
            postalCode: "",
            city: "",
            state: "",
            country: "France",
            countryCode: "FR",
            algolia: "",
            manualMode: false,
            latlng: {
                lng: null,
                lat: null,
            },
        },
    };
};

export const persistAddresses = (address) => {
    return {
        name: address.name,
        is_invoicing_address: address.isInvoicingAddress,
        is_delivery_address: address.isDeliveryAddress,
        address_line_1: address.settings.line1,
        address_line_2: address.settings.line2,
        postal_code: address.settings.postalCode,
        state: address.settings.state,
        city: address.settings.city,
        country: address.settings.country,
        country_code: address.settings.countryCode,
    };
};

// IMPORTANT : Set addressState in current state.addressSection
export const addressState = () => {
    return {
        addresses: [],
        addressTypeList: [
            {
                value: "invoice-delivery",
                label: window.i18n.__("Facturation & Livraison"),
                disable: true,
            },
            {
                value: "other",
                label: window.i18n.__("Autre"),
                disable: true,
            },
        ],
        addressesFieldsStatus: "new",
    };
};

export const addressGetters = {
    getAddress: (state) => (index) => state.addressSection.addresses[index],
    getAddresses: (state) => state.addressSection.addresses,
    getNonActiveAddresses: (state) => state.addressSection.addresses.filter((address) => !address.active),
    getAddressSettings: (state) => (index) =>
        state.addressSection.addresses[index].settings,
    getAddressName: (state) => (index) =>
        state.addressSection.addresses[index].name,
    getAddressType: (state) => (index) =>
        state.addressSection.addresses[index].type,
    getAddressesTypes: (state) => state.addressSection.addressTypeList,
    getAddressStatus: (state) => (index) =>
        state.addressSection.addresses[index].active,
    getAddressesFieldsStatus: (state) =>
        state.addressSection.addressesFieldsStatus,
    getDeliveryAndInvoiceAddress: (state) => {
        return state.addressSection.addresses.find(
            (address) =>
                address.isDeliveryAddress &&
                address.isInvoicingAddress &&
                !address.active
        );
    },
};

export const addressMutations = {
    addAddress: (state, address) => {
        state.addressSection.addresses.push(address);
    },
    removeAddress(state, index) {
        state.addressSection.addresses.splice(index, 1);
    },
    setAddressSettings(state, { index, value }) {
        state.addressSection.addresses[index].settings = value;

        //if ODS address data miss country or country_code
        if(value.countryCode && !value.country){
            for(let [code, country] of Object.entries(countryTags)){
                if(value.countryCode === code){
                    state.addressSection.addresses[index].settings.country = country;
                    break;
                }
            }
        }else if(value.country && !value.countryCode){
            for(let [code, country] of Object.entries(countryTags)){
                if(value.country === country){
                    state.addressSection.addresses[index].settings.countryCode = code;
                    break;
                }
            }
        }
    },
    setAddressName(state, { index, value }) {
        if(state.addressSection?.addresses?.length <= 0){
            state.addressSection.addresses.push(defaultAddress())
        }
        state.addressSection.addresses[index].name = value;
    },
    setAddressesTypeList: (state, { authorizedTypes }) => {
        // RESET ALL TYPES
        state.addressSection.addressTypeList.forEach(
            (type) => (type.disable = true)
        );
        // SET AVAILABLE TYPE (autorizedTypes is an array in case of multiple choices available)
        authorizedTypes.forEach((authorizedType) => {
            const selectedType = state.addressSection.addressTypeList.find(
                (type) => type.value === authorizedType
            );
            selectedType.disable = false;
        });
    },
    setAddressType: (state, { value, label, index }) => {
        const selectedAddress = state.addressSection.addresses[index];
        selectedAddress.isInvoicingAddress = value === "invoice-delivery";
        selectedAddress.isDeliveryAddress = value === "invoice-delivery";
        selectedAddress.type = { value, label };
    },
    setAddressStatus: (state, { value, index }) => {
        state.addressSection.addresses[index].active = value;
    },
    setAddressesFieldsStatus: (state, fielsStatus) => {
        state.addressSection.addressesFieldsStatus = fielsStatus;
    },
    moveInvoiceAndDeliveryOnTop: (state, InvoiceDeliveryAddress) => {
        const index = state.addressSection.addresses.indexOf(
            InvoiceDeliveryAddress
        );
        state.addressSection.addresses.splice(index, 1);
        state.addressSection.addresses.unshift(InvoiceDeliveryAddress);
    },
    clearAddresses:(state) => {
        state.addressSection.addresses = []
    }
};

export const addressActions = {
    /**
     * Check addresses'types and reset them accordingly :
     *   - If only one address is registered, only type allowed : "Delivery and Invoice"
     *   - If more than one, set available types depending on registered addresses'types
    */
    checkAndSetAuthorizedAddressTypes: ({ getters, commit }) => {
        if (getters.getAddresses.length === 1) {
            commit("setAddressesTypeList", {
                authorizedTypes: ["invoice-delivery"],
            });   
            return;
        }
        if (getters.getDeliveryAndInvoiceAddress) {
            commit("setAddressesTypeList", { authorizedTypes: ["other"] });
        } else {
            commit("setAddressesTypeList", {
                authorizedTypes: ["invoice-delivery"],
            });
        }
    },

    createNewAddress: ({ getters, dispatch, commit }) => {
        let newAddress = defaultAddress();
        if (getters.getAddresses.length) {
            newAddress.name = window.i18n.__(
                `Adresse ${getters.getAddresses.length + 1}`
            );
        }
        if (getters.getDeliveryAndInvoiceAddress) {
            newAddress.isDeliveryAddress = false;
            newAddress.isInvoicingAddress = false;
            newAddress.type = {
                value: "other",
                label: window.i18n.__("Autre"),
            };
        }
        commit("addAddress", newAddress);
        dispatch('checkAndSetAuthorizedAddressTypes');
    },
    setAddressType: ({ dispatch, commit }, { value, label, index }) => {
        commit("setAddressType", { value, label, index });
        dispatch('checkAndSetAuthorizedAddressTypes');
    },
    removeAddress({ commit }, index) {
        commit("removeAddress", index);
        commit("setAddressesFieldsStatus", "saved");
    },
    /**
     * Format Addresses array before sending to server:
     *   - If no address is labeled "Delivery and Invoice", set the first address to be
     *   - If one address is labeled "Delivery and Invoice", move it to the top of the array to match server request format
    */
    formatAddressesBeforeSubmit({ getters, commit }) {
        if(!getters.getNonActiveAddresses.length){
            return;
        }

        if (!getters.getDeliveryAndInvoiceAddress) {
            commit("setAddressType", {
                value: "invoice-delivery",
                label: window.i18n.__("Facturation & Livraison"),
                index: 0,
            });
        }
        commit(
            "moveInvoiceAndDeliveryOnTop",
            getters.getDeliveryAndInvoiceAddress
        );
    },
};
